module.exports = __webpack_public_path__ + "static/media/evaluate-not-helpful.f6eaa600.svg";